// src/utils/apiErrors.ts
import { AxiosError } from 'axios';
import { ApiError } from '../services/ApiService.types';
import { getLanguage } from '../i18n';

// Stabilny kod sytuacji z odpowiedzi serwera, np. `GROUP_NOT_FOUND`
export const getApiErrorCode = (e: unknown): string | undefined => (e as AxiosError<ApiError>).response?.data?.code;

// Serwer pisze komunikaty tylko po polsku. Przy innym języku interfejsu jego tekstu nie pokazujemy (null) —
// zostaje tekst zastępczy z plików tłumaczeń
export const polishServerText = (text: unknown): string | null => (
  getLanguage() === 'pl' && typeof text === 'string' ? text : null
);

// Tekst serwera nadaje się do pokazania tylko przy odpowiedzi z kodem: bez kodu przy 400 jest tam tablica
// angielskich tekstów, a przy 500 „Internal server error”
export const getApiErrorMessage = (e: unknown, fallback: string): string => {
  const data = (e as AxiosError<ApiError>).response?.data;

  return (data?.code && polishServerText(data.message)) || fallback;
};
